<form #formElem [formGroup]="form">
  <ion-grid class="c3-full-width">
    <ion-row>
      <ion-col size="12">
        <h4>Farmaco</h4>
      </ion-col>

      <ion-col size="12" [sizeMd]="!insulinTherapy && !assumptionsUnitControl.disabled ? 8 : 12">
        <c3-drug-selector
          #drugSelector
          [searchPending]="drugSearchLoading$ | async"
          [searchResults]="drugSearchResults$ | async"
          (search)="onDrugSearch($event)"
          formControlName="drug"
        >
        </c3-drug-selector>
      </ion-col>

      <ion-col size="12" size-md="4" *ngIf="!insulinTherapy && !assumptionsUnitControl.disabled">
        <ion-item>
          <ion-label position="stacked">Modalità di assunzione</ion-label>
          <ion-select
            placeholder="Unità"
            formControlName="assumptionsUnit"
            required
            interface="popover"
            [interfaceOptions]="{ showBackdrop: false, cssClass: 'app-popover-select-overflow' }"
          >
            <ion-select-option
              *ngFor="
                let item of ASSUMPTION_UNITS | keyvalue: sortAlphabetically;
                trackBy: trackByValue
              "
              [value]="item.key"
            >
              <span>{{ item.value }}</span>
            </ion-select-option>
          </ion-select>
        </ion-item>

        <div class="c3-validation-box-stacked">
          <ion-note>Definisci in che forma viene assunto il farmaco</ion-note>
        </div>
      </ion-col>

      <ion-col size="12" size-md="6">
        <h4>Inizio</h4>

        <ion-item>
          <ion-label position="stacked">Giorno di inizio della terapia</ion-label>
          <ion-input type="date" formControlName="startDate" [min]="todayStr" required></ion-input>
        </ion-item>

        <div
          class="c3-validation-box-stacked"
          *c3FormErrorMsg="form.get('startDate'); code: 'minDate'; let errData"
        >
          <ion-note color="danger">
            La data deve essere <strong>oggi</strong> o <strong>sucessiva a oggi</strong>
          </ion-note>
        </div>

        <div class="ion-margin-top">
          <app-hint-msg *ngIf="mode === 'edit'">
            <ion-note>
              <span>
                In caso di modifica della terapia, viene considerato come giorno di inizio della
                nuova terapia il giorno in cui la terapia è stata modificata (ovvero oggi) oppure un
                giorno successivo (ma antecedente la data di fine terapia impostata).
              </span>
            </ion-note>
          </app-hint-msg>
        </div>
      </ion-col>

      <ion-col size="12" size-md="6">
        <h4>Durata</h4>

        <ion-item lines="none">
          <ion-label>La terapia non ha una data di termine</ion-label>
          <ion-checkbox slot="start" color="secondary" formControlName="neverEnds"> </ion-checkbox>
        </ion-item>

        <ng-container *ngIf="!neverEndsControl.value">
          <app-hint-msg *ngIf="cycleInfo">
            <ion-note>
              La terapia prevede dei cicli. La durata della terapia è stata calcolata in base ai
              <strong>{{ cycleInfo.duration }}</strong> giorni previsti per la durata di un singolo
              ciclo da ripetersi <strong>{{ cycleInfo.repeat }}</strong> volte ({{
                cycleInfo.duration
              }}
              × {{ cycleInfo.repeat }} = {{ cycleInfo.duration * cycleInfo.repeat }}).
            </ion-note>
          </app-hint-msg>

          <ion-item>
            <ion-label position="stacked">Giorno di termine della terapia</ion-label>
            <ion-input
              type="date"
              formControlName="endDate"
              [min]="formValue.startDate"
              required
            ></ion-input>
          </ion-item>

          <div class="c3-validation-box-stacked">
            <ion-note
              *c3FormErrorMsg="form.get('endDate'); code: 'minDate'; let errData"
              color="danger"
            >
              <span>La data impostata deve essere almeno uguale o dopo il </span>
              <strong>{{ errData.minDate | date: "dd/MM/yyyy" }}</strong>
            </ion-note>
          </div>

          <ion-item>
            <div slot="start">
              <span>La terapia terminerà dopo </span>
            </div>

            <ion-input
              formControlName="duration"
              type="number"
              [min]="1"
              [step]="1"
              required
            ></ion-input>
            <div slot="end">
              <span> giorni</span>
            </div>
          </ion-item>

          <div
            class="c3-validation-box-stacked"
            *ngIf="
              therapyTemplate &&
              cycleInfo &&
              cycleInfo.duration * cycleInfo.repeat !== durationControl.value
            "
          >
            <app-hint-msg type="warning">
              <ion-note>
                <span
                  >La durata della terapia impostata è diffente da quella pervista dallo schema
                  terapeutico</span
                >
              </ion-note>
            </app-hint-msg>
          </div>

          <div *ngIf="cycleInfo && form.enabled" class="box-highlight ion-margin">
            <h6>Ricalcola durata con cicli</h6>
            <ion-note>
              Inserisci i nuovi parametri per ricalcolare la durata totale della terapia
            </ion-note>

            <ion-item lines="none">
              <span>Ripeti cicli di </span>
              <ion-input
                #cycleDurationInput
                type="number"
                step="1"
                min="1"
                [ngModel]="cycleInfo.duration"
                [ngModelOptions]="{ standalone: true }"
                class="short-input ion-text-center"
                disabled
              >
              </ion-input>
              <span> giorni per </span>
              <ion-input
                #cycleRepeatInput
                type="number"
                step="1"
                min="1"
                [ngModel]="cycleInfo.repeat"
                [ngModelOptions]="{ standalone: true }"
                class="short-input ion-text-center"
              >
              </ion-input>
              <span> volte</span>
            </ion-item>

            <ion-button
              (click)="
                onRecalcCycleDuration($any(cycleDurationInput.value), $any(cycleRepeatInput.value))
              "
              color="secondary"
              fill="clear"
            >
              <span>Ricalcola</span>
            </ion-button>
          </div>
        </ng-container>
      </ion-col>

      <ion-col
        *ngIf="specialFormType === 'capecitabine'"
        size="12"
        size-md="12"
        class="ion-margin-top"
      >
        <div class="c3-flex ion-align-items-center ion-justify-content-center">
          <ion-icon
            size="large"
            [src]="'information-outline' | getIcon"
            color="secondary"
            class="ion-margin-end"
          >
          </ion-icon>
          <span>
            Le terapie basate sul farmaco scelto possono essere configurate attraveso un'apposita
            form specifica.
          </span>
        </div>

        <div class="c3-flex ion-justify-content-center">
          <ion-button (click)="onOpenOncoTherapyForm()" color="secondary">
            <span>Apri form inserimento terapie oncologiche</span>
            <ion-icon slot="end" [src]="'open-in-new' | getIcon"></ion-icon>
          </ion-button>
        </div>
      </ion-col>

      <ion-col size="12">
        <h4>Tipo di terapia</h4>

        <ion-note>
          Scegliere il tipo di terapia che si intende prescrivere tra <strong>regolare</strong> o
          <strong>variabile</strong>.
          <br />
          <br />
          Una terapia <strong>regolare</strong> prevede assunzioni di farmaco con frequenza regolare
          ad intervalli di tempo ben definiti (ogni giorno, in determinati giorni della settimana,
          ...)
          <br />
          Una terapia <strong>variabile</strong> prevede frequenze di assunzione variabili di giorno
          in giorno
        </ion-note>

        <ion-list>
          <ion-radio-group
            [value]="therapyType"
            (ionChange)="setTherapyType($event?.detail?.value || 'regular')"
          >
            <ion-item lines="none">
              <ion-radio
                slot="start"
                color="secondary"
                value="regular"
                [disabled]="mode === 'view'"
              ></ion-radio>
              <ion-label>Regolare</ion-label>
            </ion-item>

            <ion-item lines="none">
              <ion-radio
                slot="start"
                color="secondary"
                value="variable"
                [disabled]="mode === 'view'"
              ></ion-radio>
              <ion-label>Variabile</ion-label>
            </ion-item>
          </ion-radio-group>
        </ion-list>
      </ion-col>

      <ng-container [ngSwitch]="therapyType">
        <ng-container *ngSwitchCase="'regular'">
          <ion-col size="12">
            <h4>Terapia Regolare</h4>

            <ion-grid>
              <ion-row>
                <ion-col size="12" size-md="12" formGroupName="regular">
                  <c3-frequency-selector formControlName="frequency"></c3-frequency-selector>
                </ion-col>

                <ion-col size="12" size-md="12" formGroupName="regular">
                  <ion-list formArrayName="assumptions">
                    <ion-list-header>
                      <div class="c3-flex-column">
                        <ion-label>Posologia</ion-label>
                        <ion-note>
                          Specifica le quantità di farmaco che il paziente deve assumere durante il
                          giorno e in quale momento della giornata
                        </ion-note>
                      </div>
                    </ion-list-header>
                    <ion-item
                      *ngFor="let a of assumptionsControls.controls; let i = index"
                      [formGroupName]="i"
                    >
                      <ion-label slot="start" class="pos-index-label"
                        ><strong>{{ i + 1 }}</strong></ion-label
                      >

                      <div class="c3-flex c3-flex-wrap ion-align-items-center gap-4">
                        <span>Il paziente assumerà</span>

                        <div>
                          <ion-input
                            type="number"
                            placeholder="Quantità"
                            min="0"
                            max="50"
                            step="0.25"
                            formControlName="quantity"
                            (ionInput)="onQuantityInput($event, assumptionsControls.controls[i])"
                            (ionBlur)="onQuantityBlur($event, assumptionsControls.controls[i])"
                            required
                            class="short-input strong-text ion-text-center"
                          >
                          </ion-input>
                        </div>

                        <span class="ion-text-lowercase">
                          &nbsp;{{
                            form.getRawValue().assumptionsUnit
                              | clinicalDataTranslation: ClinicalDataType.THERAPY
                          }}
                        </span>

                        <span *ngIf="formValue.regular?.frequency?.type === 'at_need'"
                          >&nbsp;al bisogno</span
                        >

                        <ng-container *ngIf="formValue.regular?.frequency?.type !== 'at_need'">
                          <span>&nbsp;alle ore</span>

                          <div>
                            <ion-input
                              type="time"
                              formControlName="time"
                              required
                              class="short-input strong-text"
                            >
                            </ion-input>
                          </div>

                          <span>&nbsp;nel seguente momento della giornata:</span>

                          <div>
                            <ion-select
                              placeholder="Momento della giornata"
                              formControlName="moment"
                              interface="popover"
                              [interfaceOptions]="{
                                showBackdrop: false,
                                cssClass: 'app-popover-select-overflow',
                              }"
                              class="moment-selector strong-text"
                            >
                              <ion-select-option
                                *ngFor="
                                  let item of DAY_MOMENTS | keyvalue: sortAlphabetically;
                                  trackBy: trackByValue
                                "
                                [value]="item.key"
                              >
                                <span>{{ item.value }}</span>
                              </ion-select-option>
                            </ion-select>
                          </div>
                        </ng-container>
                      </div>

                      <ion-buttons slot="end">
                        <ion-button
                          *ngIf="!isViewMode"
                          (click)="onRemoveRegularAssumption(i)"
                          color="danger"
                        >
                          <ion-icon slot="end" [src]="'delete' | getIcon"></ion-icon>
                          Rimuovi
                        </ion-button>
                      </ion-buttons>
                    </ion-item>
                  </ion-list>

                  <div
                    *c3FormErrorMsg="assumptionsControls; code: 'emptyAssumptionsList'"
                    class="c3-flex ion-align-items-center"
                  >
                    <ion-icon
                      size="small"
                      [src]="'information-outline' | getIcon"
                      color="warning"
                      class="ion-margin-end"
                    >
                    </ion-icon>
                    <ion-note>
                      È necessario inserire almeno un'assunzione per questa terapia
                    </ion-note>
                  </div>

                  <ion-button
                    (click)="onAddRegularAssumption()"
                    *ngIf="!isViewMode"
                    fill="clear"
                    shape="round"
                    color="secondary"
                  >
                    <ion-icon slot="end" [src]="'plus' | getIcon"></ion-icon>
                    <span>Aggiungi assunzione</span>
                  </ion-button>
                </ion-col>
              </ion-row>
            </ion-grid>
          </ion-col>
        </ng-container>

        <ng-container *ngSwitchCase="'variable'">
          <ion-col size="12" size-md="12" formGroupName="variable">
            <h4>Terapia Variabile</h4>

            <p>
              <ion-note>
                La terapia variabile è uno strumento avanzato che permette di personalizzare e
                definire giorno per giorno in modo puntuale le dosi di farmaco che il paziente dovrà
                assumere. Può essere usato quindi per creare terapie non regolari che, ad esempio,
                prevedono dosaggi giornalieri diversificati o giorni di pausa tra assunzioni.
              </ion-note>
            </p>
            <app-hint-msg>
              <ion-note>
                <small>
                  Una terapia variabile pervede dei cicli. Nel caso vengano definiti un numero di
                  giorni inferiore alla durata totale della terapia (determinata dalla data di fine
                  scelta), allo scadare dell'ultimo giorno indicato nello schema verranno riproposte
                  al paziente le assunzioni previste ripartendo dal primo giorno dello schema.<br />Esempio:
                  Se una terapia ha una durata di 30 giorni e viene definito uno schema di 10
                  giorni, all'11° giorno verrà segnalato al paziente di effettuare le assunzioni
                  previste per il 1° giorno indicato nello schema. Quindi, in questo caso, lo schema
                  di assunzioni verrà ripetuto 3 volte durante la terapia (cicli di 10 giorni × 3
                  ripetizioni = 30 giorni).
                </small>
              </ion-note>
            </app-hint-msg>

            <c3-therapy-variable-assumptions-table
              [formAssumptions]="variableDailyAssumptionsControls"
              [assumptionUnit]="assumptionsUnitControl.value"
              [cycleInfo]="cycleInfo"
              [maxDays]="durationControl.value"
              [therapyStartDay]="startDateControl.value"
              [therapyTemplate]="therapyTemplate"
            >
            </c3-therapy-variable-assumptions-table>
          </ion-col>
        </ng-container>

        <ng-container *ngSwitchDefault> </ng-container>
      </ng-container>

      <ion-col *ngIf="item && mode != 'insertByAV'" size="12" size-md="12">
        <h4>Storico Farmaco</h4>

        <ion-note *ngFor="let prescr of prescription">
          <b>{{ prescr.date | date: "dd/MM/yyyy, HH:mm" }}</b
          >: la terapia è stata
          <span [ngClass]="getClassOf(prescr.state)">{{ prescr.state }}</span> da
          <b>{{ prescr.doctor }}</b> della struttura <b>{{ prescr.structure }}</b
          ><br
        /></ion-note>
      </ion-col>

      <ion-col size="12" size-md="12">
        <h4>Note</h4>
        <ion-note
          >Eventuali note da allegare alla terapia, utili per il medico o il paziente</ion-note
        >

        <ion-item>
          <ion-textarea
            class="notes-input"
            formControlName="notes"
            #notesInput
            maxlength="10000"
            autoGrow
            rows="3"
          >
          </ion-textarea>
        </ion-item>

        <div class="c3-validation-box-stacked c3-flex ion-justify-content-end">
          <ion-note
            ><small>{{ notesInput.value?.length || 0 }}/10000</small></ion-note
          >
        </div>
      </ion-col>
    </ion-row>
  </ion-grid>
</form>
